import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

export default function ModalFrame({
                                       children = null,
                                       onClose = () => {
                                       },
                                       closeOnBgClick = true,
                                       bodyClass = ''
                                   }) {
    const backdropId = 'modal__backdrop';

    function toggleModal(e) {
        if (e.target.id === backdropId && closeOnBgClick) {
            onClose();
        }
    }

    return (
        <div id={backdropId} className="modal__backdrop" onClick={toggleModal}>
            <div className={`modal__body ${bodyClass}`}>{children}</div>
        </div>
    );
}

ModalFrame.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func,
    closeOnBgClick: PropTypes.bool,
    bodyClass: PropTypes.string
};
